export const couponConstants = {
  GETALL_REQUEST: 'COUPON_GETALL_REQUEST',
  GETALL_SUCCESS: 'COUPON_GETALL_SUCCESS',
  GETALL_FAILURE: 'COUPON_GETALL_FAILURE',

  GET_REQUEST: 'COUPON_GET_REQUEST',
  GET_SUCCESS: 'COUPON_GET_SUCCESS',
  GET_FAILURE: 'COUPON_GET_FAILURE',

  ADD_REQUEST: 'COUPON_ADD_REQUEST',
  ADD_SUCCESS: 'COUPON_ADD_SUCCESS',
  ADD_FAILURE: 'COUPON_ADD_FAILURE',

  UPDATE_REQUEST: 'COUPON_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'COUPON_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'COUPON_UPDATE_FAILURE',
}